import React, {useEffect, useState} from "react";
import EADialog from "../../EADialog";
import EAButton from "../../EAButton";
import EATable from "../../EATable";
import {createColumn, createSelectRowComponentColumn} from "../../../utils/ColumnUtils";
import {useHttp} from "../../../services/HttpService";
import EAButtonBar from "../../EAButtonBar";
import usePathParam from "../../../utils/usePathParam";
import {NUMBER} from "../../../utils/URLUtils";
import {getSelectableMessstellenEndpoint} from "../../../services/BescheidsService";

export function MessstellenZuordnenDialog({open, selectedIds, onCancel, onSubmit, bescheidQualitaet}) {
    const betriebsId = usePathParam("id", NUMBER);
    const [{data, loading}, fetchMessstellen] = useHttp(getSelectableMessstellenEndpoint(betriebsId, bescheidQualitaet), {manual: true});
    const [tableData, setTableData] = useState([]);
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (bescheidQualitaet && betriebsId) {
            fetchMessstellen();
        }
    }, [bescheidQualitaet, betriebsId, fetchMessstellen]);

    function handleSubmit() {
        onSubmit([...tableData.filter((m) => selected.includes(m.id))]);
    }

    useEffect(() => {
        if (!open) {
            setSelected([]);
        }
    }, [open]);

    useEffect(() => {
        if (data) {
            setTableData(data.filter((m) => !selectedIds.includes(m.id)));
        }
    }, [selectedIds, data]);

    const columns = [
        createSelectRowComponentColumn("dlgTable", "id", tableData, selected, setSelected),
        createColumn("abwasseranlage.bezeichnung", "Abwasseranlage"),
        createColumn("bezeichnung", "Bezeichnung"),
        createColumn("messstellenId", "Nummer"),
        createColumn("messstellentyp.value", "Art"),
    ];

    function createButtonBar() {
        return (
            <EAButtonBar>
                <EAButton id="cancelDlg" label="Abbrechen" onClick={onCancel}/>
                <EAButton loading={loading} disabled={loading} id="submitDlg" label="Übernehmen" onClick={handleSubmit}/>
            </EAButtonBar>
        );
    }

    function createContent() {
        return (
            <div className="gridl">
                <EATable id="dlgTable" loading={loading} data={tableData} columns={columns}/>
            </div>
        );
    }

    return (
        <EADialog
            open={open}
            titleChildren="Messstellen dem Bescheid zuordnen"
            closeFunction={onCancel}
            content={createContent()}
            buttons={createButtonBar()}
        />
    );
}
